import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store"
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/main.css'
import '@/assets/css/normalize.scss'
import moment from 'moment'
// import "./error";
// zyc 自定义组件
import zyc from '@/components/common/zyc'
import '@/assets/font/font.css'
import '@/assets/css/publicZYC.scss'
Vue.use(ElementUI);
// 注入zyc 组件集合
Vue.use(zyc);
import loginstore from '@/store' // progress bar style


/**自定义echarts主题,基于macarons*/
import * as echarts from 'echarts';
import theme from "./pages/dashboard/myTheme.json"
echarts.registerTheme('mytheme',theme)
Vue.prototype.$mytheme = theme


Vue.config.productionTip = false
import VueCookies from 'vue-cookies'

Vue.prototype.$cookies = VueCookies

// cookie过期时间30分钟
Vue.prototype.$cookies.config('30MIN', '/', '', false, 'Lax')

Vue.prototype.$moment = moment
import MetaInfo from 'vue-meta-info'

Vue.use(MetaInfo)

// 全屏显示
import fullscreen from 'vue-fullscreen'
Vue.use(fullscreen)

// 注册过滤器
import ft from './filter'
import {storePersistKey} from "./plugins/tools/Constant";
ft.forEach(item => {
  Vue.filter(item.name, item.value)
})

//元素平滑上升
import vSlideIn from "./plugins/tools/vSildeIn"
Vue.directive('sliden-in',vSlideIn)

// 处理-重复点击时会报错
const originalPush = router.push
router.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

//跳转后回到顶部
router.afterEach((to, from, next) => {
  if(to.path != from.path){
    window.scrollTo(0, 0);
  }
})

// 路由守卫-登录
router.beforeEach((to, from, next) => {
  // console.log('路由守卫-登录', to)
  next()
  // if(to.query.oauth === 'show'){
  //   store.dispatch('LoginByShow').then(() => {
  //     let url = to.fullPath.replace('oauth=show','')
  //     next({
  //       path: url
  //     })
  //   })
  // }else if (to.matched.some(res => res.meta.isLogin)) {//默认需要登录，判断是否需要登录
  //   if (loginstore.getters.access_token) {
  //     // Vue.prototype.$cookies.set('token', store.state.userStore.token, '30MIN','/', '', false, 'Lax')
  //     next();
  //   } else {
  //     let oauth_callback = ''
  //     console.log('----',to.query,'====',to.fullPath)
  //     if(to.query && to.query.oauth_callback){
  //       oauth_callback = to.query.oauth_callback
  //     }else{
  //       oauth_callback = to.fullPath
  //     }
  //     next({
  //       path: to.path.split('/')[1] + "/login?oauth_callback="+oauth_callback,
  //     });
  //   }
  // } else {
  //   next()
  // }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js